import { styled } from 'styled-components';
import { IArticlesSponsored7, defaultParams } from './params';
import { IGlobaVariables } from '../../../components/Layout/styles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IArticlesSponsored7;
}>`
  .articles-sponsored {
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;

    &-wrapper {
      display: grid;
      grid-template-columns: 1fr;
      gap: 30px;
    }

    &-article {
      position: relative;
      display: flex;
      align-items: flex-end;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border: ${({ $config: styles }) => styles.border};
      border-radius: ${({ $config: styles }) => styles.borderRadius};
      text-decoration: none;
      max-height: 350px;

      &:first-child {
        min-height: 496px;
      }

      &-image {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        border-radius: ${({ $config: styles }) => styles.borderRadius};
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &-content {
        border-radius: 0 0 8px 8px;
        z-index: 2;
        padding: 29px 17px;
        width: 100%;
        position: absolute;
        background: linear-gradient(
          to top,
          ${({ $config: styles }) => styles.group_articleCaptionBox.backgroundColor},
          transparent 100%
        );
        &-0 {
          background-color: ${({ $config: styles }) => styles.group_articleCaptionBox.backgroundColor};
          padding: 27px 21px 30px;
        }
      }

      &-title {
        color: ${({ $config: styles }) => styles.group_title.color};
        font-family: ${({ $config: styles }) => styles.group_title.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_title.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_title.fontSize};
        font-style: ${({ $config: styles }) => styles.group_title.fontStyle};
        line-height: ${({ $config: styles }) => styles.group_title.lineHeight};
        text-decoration: ${({ $config: styles }) => styles.group_title.textDecoration};
        transition: all 0.2s ease-in;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow-wrap: break-word;
        overflow: hidden;

        &-1,
        &-2 {
          margin-bottom: 0;
        }

        &:hover {
          color: ${({ $config: styles }) => styles.group_title.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_title.hover_textDecoration};
        }
      }

      &-description {
        margin-bottom: 0;
        color: ${({ $config: styles }) => styles.group_description.color};
        font-family: ${({ $config: styles }) => styles.group_description.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_description.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_description.fontSize};
        font-style: ${({ $config: styles }) => styles.group_description.fontStyle};
        line-height: ${({ $config: styles }) => styles.group_description.lineHeight};
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow-wrap: break-word;
        overflow: hidden;
        margin-bottom: 30px;
      }

      &-button {
        margin: 0 auto;
        width: max-content;
        height: 45px;
        margin-bottom: 0;
        padding: 11px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${({ $config: styles }) => styles.group_button.backgroundColor};
        border: ${({ $config: styles }) => styles.group_button.border};
        border-radius: ${({ $config: styles }) => styles.group_button.borderRadius};
        color: ${({ $config: styles }) => styles.group_button.color};
        transition: 0.2s all ease-in;
        svg {
          width: 25px;
          height: 25px;
          transition: transform 0.2s ease-in;
        }
        &:hover {
          background: ${({ $config: styles }) => styles.group_button.hover_backgroundColor};
          border: ${({ $config: styles }) => styles.group_button.hover_border};
          border-radius: ${({ $config: styles }) => styles.group_button.borderRadius};
          color: ${({ $config: styles }) => styles.group_button.hover_color};
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    .articles-sponsored {
      &-wrapper {
        grid-template-columns: 1fr 1fr;
      }

      &-article {
        &:first-child {
          grid-column: 1 / span 2;
        }
        &-content {
          &-0 {
            padding: 40px 30px 30px;
            margin-top: 0;
            width: 50%;
            position: absolute;
            right: 0;
            bottom: 0;
            height: 100%;
            border-radius: 0 ${({ $config: styles }) => styles.borderRadius}
              ${({ $config: styles }) => styles.borderRadius} 0;
          }
        }
        &-button {
          position: absolute;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}) {
    .articles-sponsored {
      &-wrapper {
        grid-template-columns: 1fr 1fr 1fr;
      }
      &-article {
        &:first-child {
          grid-column: 1 / span 2;
          grid-row: 1 / span 2;
          min-height: 100%;
        }
      }
    }
  }
`;

export default Styles;
